import { Link } from 'react-router-dom';
import useScrollReveal from '../../hooks/useScrollReveal';
import useSeo from '../../hooks/useSeo';
import { ArrowRight } from 'lucide-react';

export default function About() {
    const revealRef = useScrollReveal();

    useSeo({
        title: 'Hakkımızda | Atölye Kirpi - Tablo & Duvar Sanatı',
        description: 'Atölye Kirpi hikayesi. Kanvas tablolar, çerçeveli baskılar ve modern duvar sanatı. Yaşam alanlarınız için özenle seçilmiş koleksiyonlar.',
        keywords: 'Atölye Kirpi hakkında, tablo mağazası, kanvas tablo, duvar sanatı, dekoratif tablo',
        canonical: 'https://xn--atlyekirpi-fcb.com.tr/hakkimizda'
    });

    return (
        <div className="np-about" ref={revealRef}>
            {/* Hero */}
            <section className="np-about-hero">
                <div className="np-about-hero-inner">
                    <span className="np-about-overtitle reveal">Hikayemiz</span>
                    <h1 className="reveal">
                        Duvarlarınıza<br />Anlam Katıyoruz
                    </h1>
                    <p className="reveal">
                        Her mekan bir hikaye anlatır. Biz, duvarlarınızın hikayesini
                        özenle seçilmiş tablolarla tamamlıyoruz.
                    </p>
                </div>
            </section>

            {/* Philosophy - full width split */}
            <section className="np-about-split reveal">
                <div className="np-about-split-text">
                    <span className="np-about-label">Vizyonumuz</span>
                    <h2>Sanat Herkesin<br />Duvarında Olmalı</h2>
                    <p>
                        Atölye Kirpi, "her eve bir tablo" felsefesiyle yola çıktı.
                        Kanvas baskılardan çerçeveli eserlere, modern tasarımlardan klasik yorumlara
                        kadar geniş bir koleksiyonla duvarlarınıza karakter katıyoruz.
                    </p>
                    <p>
                        Kaliteli malzeme, titiz baskı teknikleri ve özenli paketleme ile
                        her tabloyu evinize kusursuz şekilde ulaştırıyoruz.
                    </p>
                </div>
                <div className="np-about-split-visual">
                    <div className="np-about-split-img" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=800&q=80)' }} />
                </div>
            </section>

            {/* Values - 3 col minimal */}
            <section className="np-about-values">
                <div className="np-about-values-inner">
                    <div className="np-about-value reveal">
                        <span className="np-about-value-num">01</span>
                        <h3>Yüksek Çözünürlük</h3>
                        <p>Profesyonel baskı teknolojisi ile her detayın netliğini koruyoruz. Canlı renkler, keskin hatlar.</p>
                    </div>
                    <div className="np-about-value reveal">
                        <span className="np-about-value-num">02</span>
                        <h3>Premium Malzeme</h3>
                        <p>Kalın kanvas kumaş, dayanıklı ahşap çerçeve ve solmaya karşı dirençli mürekkepler kullanıyoruz.</p>
                    </div>
                    <div className="np-about-value reveal">
                        <span className="np-about-value-num">03</span>
                        <h3>Güvenli Teslimat</h3>
                        <p>Özel koruyucu ambalajla paketlenen tablolarınız, hasarsız şekilde kapınıza ulaşır.</p>
                    </div>
                </div>
            </section>

            {/* Full width image banner */}
            <section className="np-about-banner reveal">
                <img src="https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=1600&q=80" alt="Atölye Kirpi" />
                <div className="np-about-banner-overlay">
                    <blockquote>
                        "Bir tablo, bir duvarı eve dönüştürür."
                    </blockquote>
                </div>
            </section>

            {/* Promises */}
            <section className="np-about-promises">
                <div className="np-about-promises-inner">
                    <div className="np-about-promises-head reveal">
                        <span className="np-about-label">Taahhüdümüz</span>
                        <h2>Neden Bizi<br />Tercih Etmelisiniz?</h2>
                    </div>
                    <div className="np-about-promises-grid">
                        <div className="np-about-promise reveal">
                            <h4>Ücretsiz Kargo</h4>
                            <p>Tüm siparişlerinizde ücretsiz kargo. Tablolarınız özenle paketlenerek aynı gün kargoya verilir.</p>
                        </div>
                        <div className="np-about-promise reveal">
                            <h4>Güvenli Ödeme</h4>
                            <p>iyzico altyapısı ile güvenli ödeme. Kredi kartı, banka kartı ve havale seçenekleri.</p>
                        </div>
                        <div className="np-about-promise reveal">
                            <h4>Kolay İade</h4>
                            <p>14 gün içinde koşulsuz iade hakkı. Memnuniyetiniz bizim için her şeyden önce gelir.</p>
                        </div>
                        <div className="np-about-promise reveal">
                            <h4>Tablo Danışmanlığı</h4>
                            <p>Mekanınıza uygun tablo seçiminde WhatsApp üzerinden ücretsiz danışmanlık hizmeti.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="np-about-cta reveal">
                <div className="np-about-cta-inner">
                    <h2>Koleksiyonu Keşfedin</h2>
                    <p>Evinize karakter katacak tablolar sizi bekliyor.</p>
                    <Link to="/urunler" className="np-about-cta-btn">
                        <span>Tabloları İncele</span>
                        <ArrowRight size={16} />
                    </Link>
                </div>
            </section>
        </div>
    );
}
